<h2 mat-dialog-title>Personalizar arte</h2>

<div mat-dialog-content class="arte-conteudo">

  <div *ngIf="carregando" class="arte-aviso">Abrindo a imagem...</div>
  <div *ngIf="erro" class="arte-aviso arte-erro">{{ erro }}</div>

  <div class="arte-grid" *ngIf="!carregando && !erro">

    <!-- Esquerda: a arte, onde o operador marca os campos -->
    <div class="arte-coluna-imagem">
      <p class="arte-dica">
        <ng-container *ngIf="marcando >= 0">
          Arraste um retângulo em volta de <strong>{{ campos[marcando].template }}</strong> na arte.
        </ng-container>
        <ng-container *ngIf="marcando < 0">
          Clique em <em>Marcar</em> ao lado de um campo e desenhe o retângulo sobre o placeholder.
        </ng-container>
      </p>

      <div #tela
           class="arte-tela"
           [class.arte-marcando]="marcando >= 0"
           (mousedown)="onMouseDown($event)"
           (mousemove)="onMouseMove($event)"
           (mouseup)="onMouseUp()"
           (mouseleave)="onMouseUp()">
        <canvas #preview class="arte-canvas"></canvas>

        <!-- caixas já marcadas -->
        <ng-container *ngFor="let c of campos; let i = index">
          <div *ngIf="c.caixa"
               class="arte-caixa"
               [class.arte-caixa-ativa]="marcando === i"
               [style.left.%]="c.caixa.x * 100"
               [style.top.%]="c.caixa.y * 100"
               [style.width.%]="c.caixa.w * 100"
               [style.height.%]="c.caixa.h * 100">
            <span class="arte-caixa-rotulo">{{ c.rotulo }}</span>
          </div>
        </ng-container>

        <!-- retângulo sendo desenhado -->
        <div *ngIf="rascunho"
             class="arte-caixa arte-caixa-rascunho"
             [style.left.%]="rascunho.x * 100"
             [style.top.%]="rascunho.y * 100"
             [style.width.%]="rascunho.w * 100"
             [style.height.%]="rascunho.h * 100"></div>
      </div>

      <div class="arte-preview-nav" *ngIf="nomes.length > 1">
        <button mat-button type="button" (click)="proximoNome()">
          <mat-icon>navigate_next</mat-icon> Ver com outro nome
        </button>
        <span class="arte-preview-nome">{{ nomePreview }}</span>
      </div>
    </div>

    <!-- Direita: campos e parâmetros da campanha -->
    <div class="arte-coluna-campos">

      <div class="arte-campanha">
        <mat-form-field appearance="outline" class="arte-campo-num">
          <mat-label>Desconto %</mat-label>
          <input matInput type="number" min="0" max="100"
                 [(ngModel)]="desconto" (ngModelChange)="atualizarPreview()" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="arte-campo-num">
          <mat-label>Prazo (dias úteis)</mat-label>
          <input matInput type="number" min="1" max="180"
                 [(ngModel)]="prazoDiasUteis" (ngModelChange)="atualizarPreview()" />
        </mat-form-field>
      </div>

      <div class="arte-campo" *ngFor="let c of campos; let i = index">
        <div class="arte-campo-cabecalho">
          <strong>{{ c.rotulo }}</strong>
          <span class="arte-status" [class.arte-status-ok]="c.caixa">
            {{ c.caixa ? 'marcado' : 'não marcado' }}
          </span>
        </div>

        <mat-form-field appearance="outline" class="arte-campo-template">
          <mat-label>Placeholder na arte</mat-label>
          <input matInput [(ngModel)]="c.template" (ngModelChange)="atualizarPreview()" />
        </mat-form-field>

        <div class="arte-campo-resultado">
          vira: <strong>{{ resultado(c) }}</strong>
        </div>

        <div class="arte-campo-acoes">
          <button mat-stroked-button type="button" (click)="iniciarMarcacao(i)">
            <mat-icon>crop_free</mat-icon>
            {{ marcando === i ? 'Cancelar' : (c.caixa ? 'Remarcar' : 'Marcar') }}
          </button>
          <button mat-icon-button type="button" *ngIf="c.caixa"
                  (click)="limparCampo(i)" matTooltip="Remover marcação">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </div>

        <div class="arte-campo-detalhes" *ngIf="c.caixa">
          <label>
            Texto
            <input type="color" [(ngModel)]="c.corTexto" (ngModelChange)="atualizarPreview()" />
          </label>
          <label>
            Fundo
            <input type="color" [(ngModel)]="c.corFundo" (ngModelChange)="atualizarPreview()" />
          </label>
          <label>
            Alinhar
            <select [(ngModel)]="c.align" (ngModelChange)="atualizarPreview()">
              <option value="left">Esquerda</option>
              <option value="center">Centro</option>
              <option value="right">Direita</option>
            </select>
          </label>
          <label matTooltip="Escreve o texto todo em caixa alta, como na arte original">
            <input type="checkbox" [(ngModel)]="c.maiusculas" (ngModelChange)="atualizarPreview()" />
            MAIÚSCULAS
          </label>
        </div>
      </div>

    </div>
  </div>
</div>

<div mat-dialog-actions align="end">
  <span class="arte-resumo">{{ camposMarcados }} de {{ campos.length }} campos marcados</span>
  <button mat-button type="button" (click)="cancelar()">Cancelar</button>
  <button mat-flat-button color="primary" type="button" (click)="aplicar()" [disabled]="!pronto">
    Aplicar
  </button>
</div>
